/**
 * Created by Christof Sander on 24.04.2017.
 */

module.exports = {
	model: {
		navigationElements: [
			{ title: 'Team', route: '/de/team' },
			{ title: 'Kontakt', route: '/de/kontakt' },
			{ title: 'Impressum', route: '/de/impressum' },
			{ title: 'Rechtliche Hinweise', route: '/de/rechtliche-hinweise' }
		]
	},

	events: {
		navigation: {
			type: 'click',
			selector: 'a',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var $link, href;
				if(($link = $(event.target)).length > 0 && (href = $link.attr('href')) && event.data.component.model.gridNavigator){
					event.data.component.model.gridNavigator.to(href);
				}
			}
		}
	},

	methods: {
		morph: function(route){
			this.model.route = route;
			this.refresh();
		}
	},

	hooks: {
		attach: function($element, options){
			if(!options.refresh){
				this.closest('layouts_gridNavigator_gridNavigator', function(gridNavigator){
					this.model.gridNavigator = gridNavigator;
				});
			}
		}
	}
};
